import { RootState } from "../store"

export const selectJwt = (store: RootState): string => store.auth.jwt
